export function storageGet(key, fallback = []) {
  try {
    return JSON.parse(localStorage.getItem(key) || "null") ?? fallback;
  } catch {
    return fallback;
  }
}

export function storageSet(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function buildAlertFromPosition(position, action = "") {
  const alertAction = action || position.action || position.status || "HOLD";

  return {
    id: `ALERT-${Date.now()}-${position.ticker}`,
    ticker: position.ticker,
    contract: position.contract,
    action: String(alertAction || "HOLD").toUpperCase(),
    target: position.target || "",
    thesis: position.thesis || "",
    pnl_pct: position.pnl_pct ?? null,
    dte: position.dte ?? null,
    status: "ACTIVE",
    sent: false,
    archived: false,
    created_at: new Date().toISOString(),
    source: "MSI_POSITIONS",
  };
}

export function buildAlertFromWatchlist(item, action = "BUY WATCH") {
  return {
    id: `ALERT-${Date.now()}-${item.ticker}`,
    ticker: item.ticker,
    contract: item.contract,
    action,
    target: item.target || "",
    thesis: item.thesis || item.structure || "",
    msi_score: item.msi_score ?? null,
    opportunity: item.opportunity ?? null,
    dte: item.dte ?? null,
    status: "ACTIVE",
    sent: false,
    archived: false,
    created_at: new Date().toISOString(),
    source: "MSI_WATCHLIST",
  };
}

export function alertText(alert) {
  const lines = [
    "🚨 MSI ALERT",
    "",
    `${alert.ticker} ${alert.contract || ""}`.trim(),
    `Action: ${alert.action}`,
  ];

  if (alert.target) {
    lines.push(`Target: ${alert.target}`);
  }

  if (alert.thesis) {
    lines.push(`Thesis: ${alert.thesis}`);
  }

  if (
    alert.msi_score !== null &&
    alert.msi_score !== undefined
  ) {
    lines.push(
      `MSI: ${Math.round(Number(alert.msi_score))}`
    );
  }

  if (
    alert.opportunity !== null &&
    alert.opportunity !== undefined
  ) {
    lines.push(
      `Opportunity: ${Number(alert.opportunity).toFixed(1)}%`
    );
  }

  if (
    alert.pnl_pct !== null &&
    alert.pnl_pct !== undefined
  ) {
    lines.push(
      `P/L: ${Number(alert.pnl_pct).toFixed(1)}%`
    );
  }

  if (
    alert.dte !== null &&
    alert.dte !== undefined
  ) {
    lines.push(`DTE: ${alert.dte}`);
  }

  lines.push("");
  lines.push("PlaysWithGuru MSI");

  return lines.join("\n");
}

export function addAlerts(alerts) {
  const existing = storageGet("msi_alerts", []);

  const next = [
    ...alerts,
    ...existing,
  ];

  storageSet("msi_alerts", next);

  return next;
}

export function updateAlert(updated) {
  const existing = storageGet("msi_alerts", []);

  const next = existing.map((a) =>
    a.id === updated.id ? updated : a
  );

  storageSet("msi_alerts", next);

  return next;
}

export function archiveAlert(alert) {
  return updateAlert({
    ...alert,
    archived: true,
    status: "ARCHIVED",
  });
}

export function markAlertSent(alert) {
  return updateAlert({
    ...alert,
    sent: true,
    sent_at: new Date().toISOString(),
  });
}
